import { ScrollView } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import GlassScreenLayout from "@louise/moon-ui/primitives/GlassScreenLayout";
import { BackLink, CardSurface, DialogTitleText } from "@louise/moon-ui";

type Props = {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
  overlay?: React.ReactNode;
};

export default function YouDetailScreenLayout({
  title,
  onBack,
  children,
  overlay,
}: Props) {
  const t = useTranslations();

  return (
    <GlassScreenLayout overlay={overlay}>
      <ScrollView
        contentContainerStyle={{
          padding: 16,
          paddingBottom: 100,
          maxWidth: 520,
          width: "100%",
          alignSelf: "center",
        }}
        showsVerticalScrollIndicator={false}
      >
        <BackLink
          label={t("you.shared.back")}
          action="you.shared.back"
          onPress={onBack}
          style={{ marginBottom: 16 }}
        />

        <CardSurface style={{ paddingHorizontal: 20, paddingVertical: 24 }}>
          <DialogTitleText style={{ marginBottom: 24 }}>
            {title}
          </DialogTitleText>

          {children}
        </CardSurface>
      </ScrollView>
    </GlassScreenLayout>
  );
}
